import {useState, useEffect} from 'react';
import {Card, Button, Divider, Row, Col} from 'antd';
import {CSVUploadModal} from "./CSVUpladModal";
import {getRoomMetrics, insertRoomMetrics} from "../../api/Api";
import {RoomChart} from "./RoomChart";
import * as dayjs from 'dayjs';
import {DatePickerWidget} from "../widget/DatePickerWidget";

export const RoomEnvironmentTab = ({room, onRefresh, onApiFail, props}) => {
    // these are for input
    const [modalOpen, setModalOpen] = useState(false);

    const [roomMetrics, setRoomMetrics] = useState([]);

    // date pickers
    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const now = dayjs();
    const before = (now.subtract(1, 'day'));
    const [startDate, setStartDate] = useState(before.toString());
    const [endDate, setEndDate] = useState(now.toString());
    const [displayStartDate, setDisplayStartDate] = useState(before.toString());
    const [displayEndDate, setDisplayEndDate] = useState(now.toString());

    const roomId = (room === undefined) ? undefined : room.id;

    useEffect(() => {
        if (roomId === undefined) {
            return;
        }

        getRoomMetrics(roomId, startDate, endDate).then(r => {
            setRoomMetrics(r.map((row, index) => {
                return {
                    ...row,
                    key: index,
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })

    }, [roomId, startDate, endDate, onApiFail])

    const onModalOpen = () => {
        setModalOpen(true);
    }

    const onModalCancel = () => {
        setModalOpen(false);
    }

    const onModalOk = async (values, isDelete) => {
        let i = 0;
        const pageSize = 500;
        while (i < values.length) {
            const valueWindow = values.slice(i, i+pageSize);
            await insertRoomMetrics(room.id, valueWindow, isDelete).then(r => {
                if (onRefresh) onRefresh();
            }).catch(e => {
                if ((e.status === 401) && (onApiFail)) {
                    onApiFail();
                }
            });
            i+= pageSize;
        }
        setModalOpen(false);
    }

    const onStartDateChange = (dateString, dateJs) => {
        // dueDate will be fed to the backend and retained correctly as a local date/time via mysql
        setStartDate(dateString);

        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayStartDate(dateJsString);
    }

    const onEndDateChange = (dateString, dateJs) => {
        // dueDate will be fed to the backend and retained correctly as a local date/time via mysql
        setEndDate(dateString);

        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayEndDate(dateJsString);
    }



    const cardStyle = {
        textAlign: 'left'
    }

    const dateLabelStyle = {
        marginTop: '5px'
    }

    const titleContent = <b>Room Environment</b>
    return <Card title={titleContent} style={cardStyle}>
        <CSVUploadModal open={modalOpen} onOk={onModalOk} onCancel={onModalCancel} />
        <Button onClick={onModalOpen}>Upload CSV</Button>
        <Divider />
        <Row>
            <Col span={2} style={dateLabelStyle}>
                <b>Start Date:</b>
            </Col>
            <Col>
                <DatePickerWidget placeholder={'Start'} onChange={onStartDateChange} date={displayStartDate} />
            </Col>
        </Row>
        <Row>
            <Col span={2} style={dateLabelStyle}>
                <b>End Date:</b>
            </Col>
            <Col>
                <DatePickerWidget placeholder={'End'} onChange={onEndDateChange} date={displayEndDate} />
            </Col>
        </Row>
        <Divider />
        <RoomChart events={roomMetrics} />
    </Card>
}